export default __webpack_public_path__ + "static/media/bb-00009.61af831a.png";